import requestsStatuses from 'modules/common/constants/requestsStatuses';

/**
 * Liveswitch states
 * fm.liveswitch.ConnectionState
 *
 * New = 1
 * Initializing = 2
 * Connecting = 3
 * Connected = 4
 * Failing = 5
 * Failed = 6
 * Closing = 7
 * Closed = 8
 *
 */

const failOrCloseStatuses = [5, 6, 7, 8];

export const localVideoConnected = (state) =>
  state.conference.connectionStatus.upstream === 4;


export const remoteVideoNotInDefaultState = (state) => {
  const { startConsultationRequestStatus } = state.conference.consultationInfo;
  const { downstream } = state.conference.connectionStatus;
  const { pending, success } = requestsStatuses;

  return startConsultationRequestStatus === pending
         || startConsultationRequestStatus === success
         || !!downstream;
};

export const remoteVideoConnected = (state) =>
  state.conference.connectionStatus.downstream === 4;

export const needToBeStandardVideoLayout = (status) =>
  failOrCloseStatuses.includes(status);
